// @flow
import * as React from "react";

import { Space } from "antd";
import { Link } from "react-router-dom";

// import JumpTo from "./JumpTo";
import AffiliateBalance from "./AffiliateBalance";

import type { Claims } from "overclick";

type Props = {
  claims: Claims,
};

function ProfileLink({ claims }: Props): React.Node {
  switch (claims.rol) {
    case "adm":
    case "him":
    case "ham":
    case "inm":
    case "afm":
      return (
        <Space>
          {/* <JumpTo /> */}
          <Link to={`/control-panel/users/${claims.id}`}>{claims.name}</Link>
        </Space>
      );
    case "aff":
      return (
        <Space>
          <AffiliateBalance />
          <Link to={`/affiliates/${claims.id}`}>
            ({claims.id}) {claims.name}
          </Link>
        </Space>
      );
    default:
      return null;
  }
}

export default ProfileLink;
